/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Col_SkillInputs */

const en_hub_col_skill = /** @type {(inputs: Hub_Col_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent skill`)
};

const id_hub_col_skill = /** @type {(inputs: Hub_Col_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill agen`)
};

/**
* | output |
* | --- |
* | "Agent skill" |
*
* @param {Hub_Col_SkillInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_col_skill = /** @type {((inputs?: Hub_Col_SkillInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Col_SkillInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_col_skill(inputs)
	return en_hub_col_skill(inputs)
});